import React, { useRef, useEffect, useState } from 'react';
import { ReactComponent as OhioMap } from '../OhioMap.svg';
import { Tooltip } from 'primereact/tooltip';
import { getCountyName, getCountyPath } from '../utils/countyUtils';
import styles from '../App.module.less';

const OhioMapViewer = ({ selectedCounty, onCountyClick, cmeData }) => {
  const mapRef = useRef(null);
  const [tooltipContent, setTooltipContent] = useState(null);

  // Attach tooltip handlers to map paths
  useEffect(() => {
    const attachTooltipHandlers = () => {
      const paths = mapRef.current?.querySelectorAll('path');
      
      paths?.forEach(path => {
        path.addEventListener('mouseenter', () => {
          const countyName = getCountyName(path.id);
          
          if (countyName) {
            const cme = cmeData.find(row => row.Counties.includes(countyName));
            setTooltipContent([countyName, cme]);
          }
        });
      });
    };

    if (cmeData.length > 0) {
      attachTooltipHandlers();
    }
  }, [cmeData]);

  // Highlight selected county on map
  useEffect(() => {
    if (!mapRef.current) return;

    // Remove all highlights
    mapRef.current.querySelectorAll('.highlighted').forEach(el => {
      el.classList.remove('highlighted');
    });

    // Highlight selected county
    if (selectedCounty) {
      const pathId = getCountyPath(selectedCounty);
      
      if (pathId) {
        const path = mapRef.current.querySelector(`#${pathId}`);
        if (path) {
          path.classList.add('highlighted');
        }
      }
    }
  }, [selectedCounty]);

  const handleMapClick = (e) => {
    if (e.target.tagName === 'path') {
      const pathId = e.target.getAttribute('id');
      const countyName = getCountyName(pathId);
      
      if (countyName) {
        onCountyClick(countyName);
      }
    }
  };

  return (
    <>
      <Tooltip target=".ohio-map path" mouseTrack={true} appendTo="self" position="top">
        <strong>{tooltipContent?.[0]}</strong>
        <br />
        {tooltipContent?.[1]?.Name || ''} County
      </Tooltip>

      <div className={styles.map} onClick={handleMapClick}>
        <OhioMap className={styles.background} />
        <OhioMap
          ref={mapRef}
          className={`${styles.ohioMap} ohio-map ${selectedCounty ? styles.hasSelection : ''}`}
        />
      </div>
    </>
  );
};

export default OhioMapViewer;